<ngx-skeleton-loader
  [theme]="{
    height: height,
    width: width,
    'border-radius': radius,
    margin: margin,
    background: color,
    padding: padding,
    'aspect-ratio': ratio,
    left: 0,
    top: 0,
    'position': fill ? 'absolute' : 'relative',
  }"
>
</ngx-skeleton-loader>
